import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/system';

import WaveUINoDataOverlay from '@/shared/components/utilities/WaveUINoDataOverlay';
import ProductOrder from '@/shared/types/productOrder.type';

import ProductItem from './ProductItem';

type ProductListProps = {
  productsInCart: ProductOrder[];
  currency?: string;
  removeProductFromCart: (id: string) => void;
  updateProductInCart: (value: ProductOrder) => void;
};

const ProductList: FC<ProductListProps> = ({
  productsInCart,
  currency,
  removeProductFromCart,
  updateProductInCart,
}) => {
  const { t } = useTranslation(['checkout', 'common']);

  if (productsInCart.length === 0) {
    return (
      <WaveUINoDataOverlay title={t('checkout:startScanningOrAddAProduct')} />
    );
  }

  return (
    <Stack
      spacing={2}
      sx={{
        overflowY: 'auto',
        py: 3,
      }}
    >
      {productsInCart.map((product) => (
        <ProductItem
          key={product.id}
          currency={currency}
          productInCart={product}
          removeProductFromCart={removeProductFromCart}
          updateProductInCart={updateProductInCart}
        />
      ))}
    </Stack>
  );
};

export default ProductList;
